import * as React from 'react'
import ItemRow from '../../../../common/ItemRow'
import { Article, Variation } from '../articlesContainer'
import Articles from './Articles'
import StepInfo from './StepInfo'
import Step1Info from './Step1Info'
import UrlInput from './UrlInput'
import CreateContentButton from './CreateContentButton'
import BadUrlAlert from './BadUrlAlert'
import Location from '../../adLocations/Location'
import { validateUrl } from '../../../../common/Url'
import { AdFormats } from '../../adFormat/adFormat'
import Header from '../../../../common/header/Header'

interface ScraperProps {
	articles: Article[]
	updateVariationField: (artUid: string, variationNum: number, field: keyof Variation, content: string) => void
	spinner: boolean
	urls: string[]
	addUrlInput: (e: any) => void
	removeUrlInput: (index: number) => void
	badUrlMsg: string[]
	badUrlError: boolean
	getAds: (e: any) => void
	duplicateVariation: (articleId: string, variationNo: number) => void
	removeVariation: (articleId: string, variationNo: number) => void
	addVariation: (articleId: string) => void
	setUrl: (index: number, value: string) => void
	updateArticle: (art: Article) => void
	selectedLocations?: Location[]
	adFormat: AdFormats
}

const Scraper: React.SFC<ScraperProps> = (props) => {
	const renderUrlInputs = (value: string, i: number) => {
		return (
			<ItemRow
				name={'url_' + i}
				description={`URL #${i + 1 + props.articles.length}`}
				key={i}
				validationState={value.trim() === '' ? undefined : validateUrl(value) ? 'success' : 'error'}
			>
				<UrlInput
					value={value}
					index={i}
					addUrlInput={props.addUrlInput}
					removeUrlInput={props.removeUrlInput}
					setUrl={props.setUrl}
					getAds={props.getAds}
					articles={props.articles}
				/>
			</ItemRow>
		)
	}

	const badUrlAlertInstance = (badUrlFlag: boolean) => {
		if (badUrlFlag) {
			return <BadUrlAlert badUrlMsg={props.badUrlMsg} />
		}
	}

	const renderArticles = () => {
		if (props.articles.length > 0) {
			return (
				<>
					<ItemRow name="stepinfo">
						<StepInfo />
					</ItemRow>
					<Articles
						articles={props.articles}
						updateVariationField={props.updateVariationField}
						duplicateVariation={props.duplicateVariation}
						removeVariation={props.removeVariation}
						addVariation={props.addVariation}
						updateArticle={props.updateArticle}
						selectedLocations={props.selectedLocations}
						adFormat={props.adFormat}
					/>
				</>
			)
		}
	}

	return (
		<div id="scraper">
			<Header variation="h2" style={{ paddingBottom: 30 }}>
				Create Native Ads From Your Content
			</Header>

			<ItemRow name="step1info">
				<Step1Info />
			</ItemRow>

			{props.urls.map(renderUrlInputs)}

			<ItemRow name="generateAdGroup" description="">
				<CreateContentButton spinner={props.spinner} getAds={props.getAds} />
			</ItemRow>

			{badUrlAlertInstance(props.badUrlError)}

			{renderArticles()}
		</div>
	)
}
export default Scraper
